import React, { Fragment, useEffect, useState } from 'react';
import { Row, Grid } from '@signicat/designi/components/layout';
import { Button } from '@signicat/designi/components/buttons';
import { StepProgress } from '@signicat/designi/components/steps';
import { media } from '@signicat/designi/helpers/responsive';
import { t } from "../helpers/i18n";
var Stepper = function Stepper(props) {
  var onNext = props.onNext,
    onBack = props.onBack,
    onCancel = props.onCancel,
    onSend = props.onSend,
    currentStepIndex = props.currentStepIndex,
    steps = props.steps,
    children = props.children;
  var currentPath = steps[currentStepIndex] || currentStepIndex === 0 ? steps[currentStepIndex].path : steps[0].path;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(StepProgress, {
    steps: steps,
    currentStep: currentPath,
    marginBottom: "24px"
  }), children, /*#__PURE__*/React.createElement(Row, {
    paddingTop: "32px",
    borderTop: "2px solid #eee"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    id: "cancel-order-button",
    outlined: true,
    color: "secondary",
    onClick: onCancel
  }, t('button_text_cancel'))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, currentStepIndex > 0 && /*#__PURE__*/React.createElement(Button, {
    id: "previous-step-order-button",
    icon: media.matches.tablet.and('up') ? 'back' : null,
    onClick: onBack,
    testSelector: "step-signers-back",
    outlined: true,
    color: "secondary"
  }, t('button_text_back')), currentStepIndex < steps.length - 1 && /*#__PURE__*/React.createElement(Button, {
    id: "next-step-order-button",
    icon: media.matches.tablet.and('up') ? 'forward' : null,
    onClick: onNext,
    testSelector: "step-signers-next",
    color: "primary"
  }, t('button_text_next')), currentStepIndex === steps.length - 1 && /*#__PURE__*/React.createElement(Button, {
    id: "send-order-button",
    icon: media.matches.tablet.and('up') ? 'send' : null,
    onClick: onSend,
    testSelector: "sign-order-send",
    primary: true
  }, t('signorder_button_send'))))));
};
export default Stepper;